import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowSyncOff = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 12,
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m4.64652 2.14645c-.19526.19526-.19526.51184 0 .7071l1.25 1.25c.19526.19527.51185.19527.70711 0 .19526-.19526.19526-.51184 0-.7071l-.38888-.38888c1.55662.1101 2.78525 1.40778 2.78525 2.99243 0 .26891-.03529.5294-.10153.77717l.78489.78489c.20382-.48005.31664-1.00811.31664-1.56206 0-2.14134-1.68263-3.88969-3.79784-3.99498l.40147-.40147c.19526-.19526.19526-.51184 0-.707103s-.51185-.195263-.70711 0z" }),
			/* @__PURE__ */ _jsx("path", { d: "m2.31663 4.43796c-.2038.47997-.31663 1.00797-.31663 1.56204 0 2.14134 1.68263 3.88969 3.79784 3.99498l-.40147.40142c-.19526.1953-.19526.5119 0 .7072.19526.1952.51185.1952.70711 0l1.25-1.25005c.19526-.19526.19526-.51184 0-.7071l-1.25-1.25c-.19526-.19527-.51185-.19527-.70711 0-.19526.19526-.19526.51184 0 .7071l.38888.38888c-1.55662-.1101-2.78525-1.40778-2.78525-2.99243 0-.26885.03529-.52933.10153-.77713z" }),
			/* @__PURE__ */ _jsx("path", { d: "m10.1464 10.8536c.1953.1953.5119.1953.7072 0 .1952-.1953.1952-.5118 0-.7071l-9.00005-9.00001c-.19526-.195259-.51184-.195259-.7071 0-.195266.19527-.195265.51185 0 .70711z" })
		]
	})
});
export default SvgArrowSyncOff;
